import { render, staticRenderFns } from "./SendBack.vue?vue&type=template&id=cca5e9d4&scoped=true&"
import script from "./SendBack.vue?vue&type=script&lang=js&"
export * from "./SendBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca5e9d4",
  null
  
)

export default component.exports